
























































import { Component, Vue, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import getImageMegapixels from "@/utils/Megapixels";

@Component({ components: { VModal } })
export default class LogoModal extends Vue {
  @Ref() readonly modal!: VModal;
  uploadFiles: any[] = [];
  imageErrors: {
    size: boolean;
    type: boolean;
    megapixels: boolean;
    generic: boolean;
  } = {
    size: false,
    type: false,
    megapixels: false,
    generic: false,
  };

  get fileNames() {
    return Array.from(Array(this.uploadFiles.length).keys())
      .map((x) => this.uploadFiles[x].name)
      .join(",");
  }

  show() {
    this.uploadFiles = [];
    this.modal.show();
  }

  async onFileChanged(e: any) {
    this.resetImageErrors();

    const allowedFormats = ["image/jpeg", "image/png", "image/gif"];
    this.uploadFiles = e.target.files || e.dataTransfer.files;

    if (!allowedFormats.includes(this.uploadFiles[0].type)) {
      this.imageErrors.type = true;
      this.uploadFiles = [];
      return;
    }

    if (this.uploadFiles[0].size >= 50000000) {
      this.imageErrors.size = true;
      this.uploadFiles = [];
      return;
    }

    try {
      const url = URL.createObjectURL(this.uploadFiles[0]);
      const megapixels = await getImageMegapixels(url);

      if (megapixels >= 25) {
        this.imageErrors.megapixels = true;
        this.uploadFiles = [];
        return;
      }
    } catch (e) {
      this.uploadFiles = [];
      this.imageErrors.generic = true;
      return;
    }
  }

  resetImageErrors() {
    this.imageErrors = {
      size: false,
      type: false,
      megapixels: false,
      generic: false,
    };
  }

  onCancel() {
    this.modal.hide();
  }

  onUpload() {
    this.modal.hide();
    this.$emit("upload", this.uploadFiles);
  }
}
